/**
 * KONGMX — comportamiento propio, encima de Horizon.
 *
 * Presupuesto: este archivo no debe superar los ~3 KB ni tocar
 * el hilo principal durante el scroll. Por eso las apariciones
 * usan IntersectionObserver (el navegador decide cuándo mirar)
 * y no un listener de scroll, que correría en cada cuadro.
 */

(() => {
  const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------
     Aparición al entrar en pantalla
     Marca visible cualquier .kx-reveal y le pone un índice para
     escalonar hermanos. Se deja de observar en cuanto aparece:
     la animación es de una sola vez, no un yo-yo al hacer scroll.
     ---------------------------------------------------------- */
  const revelar = () => {
    const elementos = document.querySelectorAll('.kx-reveal:not(.is-visible)');
    if (!elementos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observador = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((entrada) => {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('is-visible');
          observador.unobserve(entrada.target);
        });
      },
      // Se dispara un poco antes del borde inferior para que el
      // elemento ya esté completo cuando el ojo llega a él.
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );

    elementos.forEach((el, i) => {
      // El escalonado sólo aplica entre hermanos directos.
      const hermanos = el.parentElement
        ? [...el.parentElement.children].filter((n) => n.classList.contains('kx-reveal'))
        : [];
      const indice = hermanos.indexOf(el);
      el.style.setProperty('--kx-i', indice > -1 ? Math.min(indice, 6) : Math.min(i, 6));
      observador.observe(el);
    });
  };

  const iniciar = () => {
    revelar();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }

  /* En el editor de temas las secciones se vuelven a pintar sin
     recargar. Sin esto, una sección recién añadida se quedaría
     invisible (opacity: 0) mientras el comerciante la edita. */
  document.addEventListener('shopify:section:load', revelar);
  document.addEventListener('shopify:section:select', revelar);
})();
